import { useCallback } from "react";

function debounce(func, delay) {
  let timerId;
  return function (...args) {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export default function useDebounce(func, delay = 300) {
  // eslint-disable-next-line
  const debouncedFn = useCallback(debounce(func || (() => { }), delay), [func]);
  return debouncedFn;
}
